module.exports = __webpack_public_path__ + "media/img/main_bg-f41c530350570b396e2c828e563019d1.webp";